import { useAtom } from "jotai";
import { useCallback, useEffect, useRef } from "react";
import { currentSessionIdAtom, currentSpaceAtom } from "../../jotai/atoms";
import useInterval from "../../utils/useInterval";

export default function useSpaceSessionTracker() {
  const [sessionId] = useAtom(currentSessionIdAtom);
  const [currentSpace] = useAtom(currentSpaceAtom);
  const started = useRef(false);

  useEffect(() => {
    if (sessionId && currentSpace) {
      fetch("/api/space/session-start", {
        method: "POST",
        body: JSON.stringify({
          sessionId,
          spaceId: currentSpace.id,
          startedAt: new Date().toISOString(),
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        if (res.status === 200) {
          started.current = true;
        }
      });
    }
  }, [currentSpace, sessionId]);

  const ping = useCallback(() => {
    if (!started.current || !sessionId) return;

    const params = new Blob([JSON.stringify({ sessionId })], {
      type: "application/json",
    });

    navigator.sendBeacon("/api/space/session-ping", params);
  }, [started, sessionId]);

  useEffect(() => {
    window.addEventListener("beforeunload", ping);
    window.addEventListener("visibilitychange", ping);

    return () => {
      window.removeEventListener("beforeunload", ping);
      window.removeEventListener("visibilitychange", ping);
    };
  }, [ping]);

  useInterval(ping, 60 * 1000);
}
